import { Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import * as APIModels from "../../../../models";
import Select, { ActionMeta } from "react-select";
import { SubmissionService } from "../../../../services/SubmissionService";
import CaseSearch from "../CaseSearch";
import Pleadings from "../Pleadings";
import Fees from "../Fees";
import { EmptyGuid } from "../../../../models";
import { useParams } from "react-router-dom";
import { DataService } from "../../../../services/DataService";
type MyOptionType = { label: string; value: string };

interface QueryParams {
    submissionId?: string;
    attorneyId?: string;
    filter?: string;
    state?: string;
}

type OfficerOptionType = { label: string; value: string };

export default function Order({
    submission,
    onSelectDocument,
    setNextSubmission,
    filter,
}: {
    submission: APIModels.Submission;
    onSelectDocument: (doc: APIModels.Document, index: number) => void;
    setNextSubmission: (next: APIModels.Submission) => void;
    filter?: string;
}) {
    const [completedSubmission, setCompletedSubmission] = useState(submission);
    const [completedDocs, setCompletedDocs] = useState(submission.documents!);
    const [completedFees, setCompletedFees] = useState(submission.fees ?? []);
    const [submitting, setSubmitting] = useState(false);
    const [feeLoading, setFeeLoading] = useState<boolean>(false);

    const [officerOptions, setOfficerOptions] = useState(
        [] as OfficerOptionType[]
    );

    const handleFeeLoading = () => {
        console.log({ "Handeling fees loading: ": !feeLoading });
        setFeeLoading((prev) => {
            return !prev;
        });
    };

    const params: QueryParams = useParams<{
        submissionId?: string;
        attorneyId?: string;
        filter?: string;
        state?: string;
    }>();

    useEffect(() => {
        setCompletedSubmission(submission);
    }, [submission]);

    const onSearchComplete = (
        request: APIModels.CaseSearch,
        result: APIModels.CourtCase
    ) => {
        const updatedCaseData =
            completedSubmission.caseData ?? new APIModels.CaseData();
        updatedCaseData.ucn = result.ucn;
        updatedCaseData.county = result.county;
        updatedCaseData.countyID = request.countyID;
        updatedCaseData.division = result.division;
        updatedCaseData.divisionID = request.divisionID;
        updatedCaseData.courtCaseNumber = result.caseNumber;
        updatedCaseData.caseTitle = result.caseTitle;
        updatedCaseData.caseTypeID = result.caseTypeID;
        updatedCaseData.caseSubTypeID = result.caseSubTypeID;
        updatedCaseData.year = request.year;
        updatedCaseData.sequenceNumber = request.sequenceNumber;

        setCompletedSubmission({ ...submission, caseData: updatedCaseData });
    };

    const onOptInComplete = (result?: APIModels.Submission) => {
        // Move on to the next submission, mirroring onSubmit's navigation.
        if (result && result.id) {
            window.location.href = `/efile?submissionId=${result.id}&filter=${filter}`;
        } else {
            window.location.href = "/queue";
        }
    };

    const onUpdateDoc = (doc: APIModels.Document) => {
        const docs = [...completedSubmission.documents!];
        const index = completedSubmission.documents?.findIndex(
            (v) => v.id == doc.id
        );
        docs[index!].documentType = doc.documentType;
        docs[index!].documentTypeID = doc.documentTypeID;
        setCompletedDocs(docs);
    };

    const onFeeChange = (fees: APIModels.FeeType[]) => {
        setCompletedFees(fees);
    };

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        if (!completedSubmission.caseData?.judicialOfficerID) {
            alert("Please select a Judicial Officer");
        } else {
            setSubmitting(true);
            SubmissionService.submit({
                attorneyId: completedSubmission.attorneyID,
                filter: params.filter,
                state: completedSubmission.portalIdentifier,
                body: {
                    ...completedSubmission,
                    documents: completedDocs,
                    fees: completedFees,
                },
            }).then(
                (resp) => {
                    console.log(resp);
                    if (resp.data && resp.data.id) {
                        //show efile success
                        //setNextSubmission(resp.data);
                        window.location.href = `/efile?submissionId=${resp.data.id}&filter=${filter}`;
                    } else {
                        //TODO: Show error
                        window.location.href = "/queue";
                    }
                },
                (error) => {
                    setSubmitting(false);
                    console.log(error);
                }
            );
        }
        e.preventDefault();
    };

    const onOfficerChange = (
        value: OfficerOptionType | null,
        actionMeta: ActionMeta<OfficerOptionType>
    ) => {
        setCompletedSubmission({
            ...completedSubmission,
            caseData: {
                ...completedSubmission.caseData,
                judicialOfficerID: value!.value,
            },
        });
    };

    useEffect(() => {
        DataService.getJudicialOfficers({
            divisionId: completedSubmission.caseData?.divisionID || "",
        }).then(
            (resp) => {
                if (resp.successful && resp.data) {
                    const options = resp.data.map((v, i) => {
                        return { value: v.ePortalID!, label: v.name! };
                    });
                    setOfficerOptions(options);
                } else {
                    console.log(resp.errorMessage);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, [completedSubmission.caseData?.divisionID]);

    return (
        <>
            <form className="needs-validation" onSubmit={onSubmit}>
                <div>
                    <div className="mb-3">
                        <label className="form-label">UCN</label>
                        <a style={{ display: "block" }}>
                            {completedSubmission.caseData?.ucn}
                        </a>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Case Title</label>
                        <div>{completedSubmission.caseData?.caseTitle}</div>
                    </div>
                </div>
                <div
                    className="accordion accordion-flush"
                    id="accordionFlushExample"
                >
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingOne">
                            <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseOne"
                                aria-expanded="true"
                                aria-controls="flush-collapseOne"
                            >
                                Case Search
                            </button>
                        </h2>
                        <div
                            id="flush-collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="flush-headingOne"
                            data-bs-parent="#accordionFlushExample"
                        >
                            <div className="accordion-body">
                                <CaseSearch
                                    submission={completedSubmission}
                                    onSearchComplete={onSearchComplete}
                                    onOptInComplete={onOptInComplete}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingTwo">
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseTwo"
                                aria-expanded="false"
                                aria-controls="flush-collapseTwo"
                            >
                                Documents
                            </button>
                        </h2>
                        <div
                            id="flush-collapseTwo"
                            className="accordion-collapse collapse"
                            aria-labelledby="flush-headingTwo"
                            data-bs-parent="#accordionFlushExample"
                        >
                            <div className="accordion-body">
                                <Pleadings
                                    submission={completedSubmission}
                                    originalDocs={completedDocs}
                                    onSelectDocument={onSelectDocument}
                                    onUpdateDoc={onUpdateDoc}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2
                            className="accordion-header"
                            id="flush-headingThree"
                        >
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseThree"
                                aria-expanded="false"
                                aria-controls="flush-collapseThree"
                            >
                                Judicial Officer
                            </button>
                        </h2>
                        <div
                            id="flush-collapseThree"
                            className="accordion-collapse collapse"
                            aria-labelledby="flush-headingThree"
                            data-bs-parent="#accordionFlushExample"
                        >
                            <div className="accordion-body">
                                <div className="mb-3">
                                    <div className="row">
                                        <label
                                            htmlFor="selOfficer"
                                            className="form-label"
                                        >
                                            Judicial Officer
                                        </label>
                                        <Select
                                            id="selOfficer"
                                            name="selOfficer"
                                            value={officerOptions.filter(
                                                (c) =>
                                                    c.value ===
                                                        completedSubmission
                                                            .caseData
                                                            ?.judicialOfficerID ||
                                                    ""
                                            )}
                                            options={officerOptions}
                                            onChange={onOfficerChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12" style={{ textAlign: "center" }}>
                        {submitting ? (
                            <button
                                className="btn btn-primary"
                                type="button"
                                disabled={true}
                            >
                                <span
                                    className="spinner-border spinner-border-sm me-1"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Submitting...
                            </button>
                        ) : (
                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
                        )}
                    </div>
                </div>
            </form>
        </>
    );
}
